﻿// utils/config.js

/**
 * Configurações de ambiente da aplicação
 */
class Config {
  constructor() {
    this.currentOrigin = window.location.origin;
    this.environment = this.detectEnvironment();
    this.urls = this.getUrls();
  }

  /**
   * Detecta o ambiente atual baseado na origin
   */
  detectEnvironment() {
    const localOrigin = process.env.REACT_APP_LOCAL_ORIGIN || 'http://localhost:3001';
    const intraOrigin = process.env.REACT_APP_INTRA_ORIGIN || 'http://sacp-wis.devcoski.intra';

    if (this.currentOrigin === localOrigin) {
      return 'local';
    } else if (this.currentOrigin === intraOrigin) {
      return 'intra';
    } else {
      return 'external';
    }
  }

  /**
   * Retorna as URLs baseadas no ambiente
   */
  getUrls() {
    const configs = {
      local: {
        url1: process.env.REACT_APP_LOCAL_URL1 || 'http://localhost:90/',
        url2: process.env.REACT_APP_LOCAL_URL2 || 'http://localhost:80/',
        url3: process.env.REACT_APP_LOCAL_URL3 || 'http://localhost:3333/'
      },
      intra: {
        url1: process.env.REACT_APP_INTRA_URL1 || 'http://api-tkr.devcoski.intra',
        url2: process.env.REACT_APP_INTRA_URL2 || 'http://api2-tkr.devcoski.intra',
        url3: process.env.REACT_APP_INTRA_URL3 || 'http://api3-tkr.devcoski.intra'
      },
      external: {
        url1: process.env.REACT_APP_EXT_URL1 || 'https://api-tkr.devcoski.tech',
        url2: process.env.REACT_APP_EXT_URL2 || 'https://api2-tkr.devcoski.tech',
        url3: process.env.REACT_APP_EXT_URL3 || 'https://api3-tkr.devcoski.tech'
      }
    };

    return configs[this.environment];
  }

  /**
   * Valida se uma URL é© vé¡lida
   */
  isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Inicializa as configurações no localStorage
   */
  initialize() {
    const { url1, url2, url3 } = this.urls;

    // Validação das URLs
    if (!this.isValidUrl(url1) || !this.isValidUrl(url2) || !this.isValidUrl(url3)) {
    }

    // Log das configurações
    // Salva no localStorage
    localStorage.setItem('urlParsed', url1);
    localStorage.setItem('urlOperacional', url2);
    localStorage.setItem('urlNodeOp', url3);
    localStorage.setItem('environment', this.environment);
  }

  /**
   * Getters para facilitar o acesso
   */
  get url1() {
    return this.urls.url1;
  }

  get url2() {
    return this.urls.url2;
  }

  get env() {
    return this.environment;
  }
}

export default new Config();
